import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";
import { Button } from "@tellescope/design-system";
import type { Form, FormField, FormResponse } from "@tellescope/types-models";
import { PendingFormContent } from "../../../components/blocks/NativeFormResponseDialog/PendingFormContent";
import { FormAccessCodeIframe } from "./FormAccessCodeIframe";
import { usePendingFormView } from "./usePendingFormView";

interface PendingFormViewProps {
  formResponse: FormResponse;
  form: Form;
  fields: FormField[];
}

export const PendingFormView = ({ formResponse, form, fields }: PendingFormViewProps) => {
  const { t } = useTranslation("forms");
  const {
    usesNewFormsExperience,
    continueAfterSubmit,
    finish,
    continueToFormInApp,
    documentGroupBackUrl,
    handleIframeSubmitted,
    resetFormStore,
  } = usePendingFormView({ formResponse, form, fields });

  return (
    <div className="h-[100dvh] flex flex-col">
      <div className="flex items-center gap-3 px-4 py-3 border-b flex-shrink-0">
        <Button asChild variant="ghost" size="sm" iconOnly className="h-8 w-8 p-0" aria-label={t("Go Back")}>
          <Link to="/documents" onClick={resetFormStore}>
            <ArrowLeft className="h-4 w-4" />
          </Link>
        </Button>
        <h1 className="text-base font-medium truncate">{formResponse.formTitle}</h1>
      </div>

      {usesNewFormsExperience ? (
        <div className="flex-1 overflow-hidden flex flex-col items-center">
          <div className="flex flex-col w-full max-w-[650px] flex-1 min-h-0">
            <PendingFormContent
              formResponse={formResponse}
              surface="form-response-dialog"
              onComplete={finish}
              continueAfterSubmit={continueAfterSubmit}
              continueToFormInApp={continueToFormInApp}
              documentGroupBackUrl={documentGroupBackUrl}
            />
          </div>
        </div>
      ) : (
        <FormAccessCodeIframe formResponse={formResponse} onSubmitted={handleIframeSubmitted} />
      )}
    </div>
  );
};
